import { render, staticRenderFns } from "./StepForm3.vue?vue&type=template&id=089c1f89&scoped=true&"
import script from "./StepForm3.vue?vue&type=script&lang=ts&"
export * from "./StepForm3.vue?vue&type=script&lang=ts&"
import style0 from "./StepForm3.vue?vue&type=style&index=0&id=089c1f89&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089c1f89",
  null
  
)

export default component.exports